import { Grid, TextareaAutosize } from '@mui/material'
import * as Redux from 'redux'
import BaseSelect from '@Components/Form/BaseSelect/BaseSelect'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import './inspection-info.scss'
import ClassificationAction from '@ClientActions/classification.action'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import { BaseCheckBox } from '@Components/Form/BaseCheckBox/BaseCheckBox'
import { EClassifications } from '@Enum/classifications.enum'
import { Controller, useForm } from 'react-hook-form'
import { FormService } from '@Services/form.service'
import InspectionInfoActions from '@Stores/inspection/actions/inspection-info.action'
import { ICommonQuery } from '@Models/common.model'
import BaseCreatableSelect from '@Components/Form/BaseCreatableSelect/BaseCreatableSelect'
import useSearch from '@Hooks/useSearch'
import { APIServices } from '@Services/api.service'

interface IInspectionInfoProps {
    makes?: []
    models?: []
    getMakes?: any
    getModels?: any
    getForm?: () => void
    inspectionForm?: []
    inspectionFormId?: string
    createForm?: (params: any) => Promise<any>
    getInspectionBySearch?: () => void
    inspectionDetail?: any
    getClassificationsBySuggestion?: (params?: any) => void
    classifications?: any
    detailInspection?: any
    setInspectionQueries?: (params?: any) => void
}

function InspectionInfo(props: IInspectionInfoProps) {
    const {
        getMakes,
        getModels,
        makes,
        models,
        inspectionForm,
        inspectionFormId,
        inspectionDetail,
        getForm,
        createForm,
        getInspectionBySearch,
        getClassificationsBySuggestion,
        classifications,
        detailInspection,
        setInspectionQueries,
    } = props
    const defaultValues = {
        id: '',
        make: '',
        model: '',
        caliber: '',
        serial: '',
    }
    const ac = new AbortController()
    const [answers, setAnswers] = useState([] as any)
    const [textAreaAnswers, setTextAreaAnswers] = useState([] as any)
    const [errorAnswers, setErrorAnswers] = useState(false)
    const [submit, setSubmit] = useState(false)
    const [searchResult, setSearchResult] = useState({})

    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        watch,
    } = useForm({ defaultValues })

    const watchMake = watch('make')
    const watchModel = watch('model')
    const watchCaliber = watch('caliber')
    const watchId = watch('id')

    useEffect(() => {
        // if (getInspectionBySearch) getInspectionBySearch()
        if (getClassificationsBySuggestion) getClassificationsBySuggestion()
        getMakes()
        // getModels()
        if (getForm) {
            getForm()
        }
        return () => {
            ac.abort()
        }
    }, [])

    // custom hooks
    const [search, setDebounceSearch] = useSearch('')
    useEffect(() => {
        if (setInspectionQueries && getInspectionBySearch) {
            setInspectionQueries({ inspectorId: search?.debounceString })
            getInspectionBySearch()
        }
        return () => {
            APIServices.axiosCancelToken()
        }
    }, [search?.debounceString])

    const onSubmit = (formData: any) => {
        setErrorAnswers(true)
        const answersData = [...answers, ...textAreaAnswers]
        if (answersData?.length) {
            const body = {
                inspectionFormId,
                items: [
                    {
                        make: formData?.make,
                        model: formData?.model,
                        caliber: formData?.caliber,
                        serialNumber: formData?.serial,
                        itemId: formData?.id ? formData?.id : '',
                    },
                ],
                name: '',
                description: '',
                questionAnswers: answersData,
                inspectionScheduleId: search?.debounceString
                    ? detailInspection?.id
                    : '',
            }
            // console.log(body, 'body')

            if (createForm) {
                createForm(body).then(() => {
                    reset(defaultValues)
                    setAnswers([])
                    const clearTextArea = textAreaAnswers?.map((item: any) => {
                        const ans = item?.answers?.map((cItem: any) => {
                            return { ...cItem, name: '' }
                        })
                        return { ...item, answers: ans }
                    })
                    setTextAreaAnswers(clearTextArea)
                    setErrorAnswers(false)
                    setSubmit(false)
                    setDebounceSearch('')
                })
            }
        }
    }

    const onChangeTextArea = (evt: any, item: any) => {
        if (evt.target.value) {
            const obj = {
                inspectionQuestionId: item?.id,
                answers: [
                    {
                        name: evt.target.value,
                        score: item?.score,
                    },
                ],
            }
            setTextAreaAnswers([
                ...textAreaAnswers.filter(
                    (ques: any) => ques?.inspectionQuestionId !== item?.id
                ),
                obj,
            ])
        } else {
            setTextAreaAnswers(
                textAreaAnswers.filter(
                    (ques: any) => ques?.inspectionQuestionId !== item?.id
                )
            )
        }
    }

    const handleChangeCheckBox = (evt: any, item: any) => {
        if (evt.target.checked) {
            const obj = {
                inspectionQuestionId: item?.inspectionQuestionId,
                answers: [
                    {
                        name: item?.name,
                        score: item?.score,
                    },
                ],
            }

            setAnswers([
                ...answers.filter(
                    (ans: any) =>
                        ans?.inspectionQuestionId !== item?.inspectionQuestionId
                ),
                obj,
            ])
        } else {
            setAnswers(
                answers.filter(
                    (ans: any) =>
                        ans?.inspectionQuestionId !== item?.inspectionQuestionId
                )
            )
        }
    }

    const onChangeMake = (value: string) => {
        setValue('model', '')
        const params = {
            parentCode: value,
        }
        getModels(params)
    }

    useEffect(() => {
        const answersData = [...answers, ...textAreaAnswers]
        if (answersData?.length) {
            setErrorAnswers(false)
        } else {
            setErrorAnswers(true)
        }
    }, [answers, textAreaAnswers])

    const selectClassificationChange = (event: any, type: string) => {
        // const paras
        switch (type) {
            case 'MAKE':
                setValue('model', '')
                setValue('caliber', '')
                break
            case 'MODEL':
                setValue('caliber', '')
                break
            default:
                break
        }
        // const params = {
        //     make: watchMake,
        //     model: watchModel,
        //     caliber: watchCaliber,
        // }

        // if (getClassificationsBySuggestion)
        //     getClassificationsBySuggestion(params)
    }

    // useEffect(() => {
    //     if (!inspectionDetail) return
    //     if (inspectionDetail?.items?.length) {
    //         getModels()
    //         const newValue = {
    //             make: inspectionDetail?.items[0]?.make || '',
    //             model: inspectionDetail?.items[0]?.model || '',
    //             caliber: inspectionDetail?.items[0]?.caliber || '',
    //             serial: inspectionDetail?.items[0]?.serialNumber || '',
    //         }
    //         reset(newValue)
    //     }
    //     if (inspectionDetail?.form?.questions) {
    //         inspectionDetail?.form?.questions?.forEach((item: any) => {
    //             item?.child.forEach((c: any) => {
    //                 const answer = c?.answers?.map((an: any) => {
    //                     const v = {
    //                         name: an?.name,
    //                         score: an?.score,
    //                     }
    //                     return {
    //                         answers: [v],
    //                         inspectionQuestionId: an?.inspectionQuestionId,
    //                     }
    //                 })
    //                 if (answer?.length) {
    //                     if (c?.questionType === 'MULTIPLE-CHOICE') {
    //                         setAnswers((oldValue: any) => [
    //                             ...oldValue,
    //                             answer[0],
    //                         ])
    //                     } else {
    //                         setTextAreaAnswers((oldValue: any) => [
    //                             ...oldValue,
    //                             answer[0],
    //                         ])
    //                     }
    //                 }
    //             })
    //         })
    //     }
    // }, [inspectionDetail])

    useEffect(() => {
        if (!search?.debounceString) {
            const detail = {
                serial: '',
                make: '',
                model: '',
                caliber: '',
                id: '',
            }
            reset(detail)
        }

        if (
            detailInspection &&
            search?.debounceString &&
            setInspectionQueries
        ) {
            setSearchResult(detailInspection)
            if (detailInspection?.items?.length) {
                const detail = {
                    serial: detailInspection?.items[0]?.serialCode || '',
                    make: detailInspection?.items[0]?.make?.name || '',
                    model: detailInspection?.items[0]?.model?.name || '',
                    caliber: detailInspection?.items[0]?.caliber || '',
                    id: detailInspection?.items[0]?.id || '',
                }
                reset(detail)
            } else {
                const detail = {
                    serial: '',
                    make: '',
                    model: '',
                    caliber: '',
                    id: '',
                }
                reset(detail)
            }
        }
        // console.log(watchMake, watchModel, watchCaliber)
    }, [search?.debounceString, detailInspection])

    useEffect(() => {
        const params = {
            make: watchMake,
            model: watchModel,
            caliber: watchCaliber,
        }
        if (getClassificationsBySuggestion)
            getClassificationsBySuggestion(params)
    }, [
        watchMake,
        watchModel,
        watchCaliber,
        search?.debounceString,
        detailInspection,
    ])

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="page-inspection-info page-white-card">
                <div className="position-relative">
                    <p className="educator-headline">INSPECTION</p>
                    <input
                        onChange={(e: any) => {
                            setDebounceSearch(e?.target?.value)
                        }}
                        value={search?.searchString}
                        className="input-headline"
                        type="text"
                        placeholder="Customer Inspection ID Number"
                    />
                </div>
                <Grid container spacing={2} className="mb-3">
                    <Grid item sm={2}>
                        <Controller
                            control={control}
                            name="make"
                            defaultValue=""
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <BaseCreatableSelect
                                    // inputRef={ref}
                                    label="Make"
                                    value={value}
                                    options={classifications?.makes || []}
                                    onChange={(event: any) => {
                                        onChange(event)
                                        // onChangeMake(event?.target.value)
                                        selectClassificationChange(
                                            event,
                                            'MAKE'
                                        )
                                    }}
                                    fullWidth
                                    error={errors?.make && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'make',
                                        'Make'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={2}>
                        <Controller
                            control={control}
                            name="model"
                            defaultValue=""
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <BaseCreatableSelect
                                    // inputRef={ref}
                                    label="Model"
                                    value={value}
                                    onChange={(event: any) => {
                                        onChange(event)
                                        selectClassificationChange(
                                            event,
                                            'MODEL'
                                        )
                                    }}
                                    options={classifications?.models}
                                    fullWidth
                                    error={errors?.model && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'model',
                                        'Model'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={2}>
                        <Controller
                            control={control}
                            name="caliber"
                            defaultValue=""
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                // <RedditTextField
                                //     {...field}
                                //     inputRef={ref}
                                //     value={value}
                                //     onChange={onChange}
                                //     label="Caliber"
                                //     className="reddit-input w-100"
                                //     variant="filled"
                                //     error={errors?.caliber && true}
                                //     helperText={FormService.getErrorMessage(
                                //         errors,
                                //         'caliber',
                                //         'Caliber'
                                //     )}
                                // />
                                <BaseCreatableSelect
                                    value={value}
                                    onChange={(e: any) => {
                                        onChange(e)
                                        selectClassificationChange(e, 'CALIBER')
                                    }}
                                    options={classifications?.calibers || []}
                                    label="Caliber"
                                    fullWidth
                                    error={errors?.caliber && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'caliber',
                                        'Caliber'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={2}>
                        <Controller
                            control={control}
                            name="serial"
                            defaultValue=""
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    inputRef={ref}
                                    value={value}
                                    onChange={onChange}
                                    label="Serial Number"
                                    className="reddit-input w-100"
                                    variant="filled"
                                    error={errors?.serial && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'serial',
                                        'Serial Number'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
                <p className="inspection-title">Visual Inspection </p>
                <div className="page-visual-inspection">
                    {inspectionForm?.map((items: any, i: number) => {
                        return (
                            <React.Fragment key={items?.id}>
                                <div className="p-4">
                                    <div className="title d-flex">
                                        <p className="w-50 mb-1">
                                            {i + 1}. {items?.name}
                                        </p>
                                        <div className="w-25">
                                            <span className="d-inline-block mx-2">
                                                Yes
                                            </span>
                                            <span className="d-inline-block mx-2">
                                                No
                                            </span>
                                        </div>
                                    </div>
                                    <div>
                                        {items?.child
                                            ?.filter(
                                                (ques: any) =>
                                                    ques?.questionType ===
                                                    'MULTIPLE-CHOICE'
                                            )
                                            ?.map((ques: any, j: number) => {
                                                const checkedAnswer =
                                                    answers?.find(
                                                        (item: any) =>
                                                            item?.inspectionQuestionId ===
                                                            ques?.id
                                                    )

                                                return (
                                                    <div
                                                        className="question-box"
                                                        key={ques?.id}
                                                    >
                                                        <p className="m-0 w-50">
                                                            {i + 1}
                                                            {String.fromCharCode(
                                                                65 + j
                                                            )}
                                                            . {ques?.name}
                                                        </p>
                                                        {ques?.answerOptions.map(
                                                            (ans: any) => {
                                                                return (
                                                                    <div
                                                                        key={
                                                                            ans?.sequence
                                                                        }
                                                                    >
                                                                        <BaseCheckBox
                                                                            value={
                                                                                ans?.name
                                                                            }
                                                                            onChange={(
                                                                                event: any
                                                                            ) =>
                                                                                handleChangeCheckBox(
                                                                                    event,
                                                                                    ans
                                                                                )
                                                                            }
                                                                            checked={
                                                                                checkedAnswer
                                                                                    ?.answers?.[0]
                                                                                    ?.name ===
                                                                                ans?.name
                                                                            }
                                                                        />
                                                                    </div>
                                                                )
                                                            }
                                                        )}
                                                    </div>
                                                )
                                            })}
                                        {items?.child
                                            ?.filter(
                                                (ques: any) =>
                                                    ques?.questionType ===
                                                    'COMMENT'
                                            )
                                            .map((ques: any, j: number) => {
                                                const textArea =
                                                    textAreaAnswers?.find(
                                                        (item: any) =>
                                                            item?.inspectionQuestionId ===
                                                            ques?.id
                                                    )

                                                return (
                                                    <div
                                                        className="mt-3 w-50"
                                                        key={ques?.id}
                                                    >
                                                        <p className="small-gray-text mb-1">
                                                            {ques?.name}
                                                        </p>
                                                        {/* <div className="commment-box" /> */}
                                                        <TextareaAutosize
                                                            onChange={(
                                                                event
                                                            ) => {
                                                                onChangeTextArea(
                                                                    event,
                                                                    ques
                                                                )
                                                            }}
                                                            value={
                                                                textArea
                                                                    ?.answers?.[0]
                                                                    ?.name
                                                            }
                                                            className="text-area gray-bg"
                                                        />
                                                    </div>
                                                )
                                            })}
                                    </div>
                                </div>
                                {inspectionForm?.length - 1 !== i && (
                                    <div className="page-hr" />
                                )}
                            </React.Fragment>
                        )
                    })}
                </div>
            </div>
            {submit && errorAnswers && (
                <div className="text-right" style={{ marginRight: '35px' }}>
                    <span className="error-msg">
                        Please Fill the Question above!
                    </span>
                </div>
            )}
            <div className="text-right mt-2">
                <button
                    type="submit"
                    className="educator-primary-btn"
                    style={{ marginRight: '30px' }}
                    onClick={() => setSubmit(true)}
                >
                    Save
                </button>
            </div>
        </form>
    )
}

const mapStateToProps = (store: any) => {
    const { makes, models, safeTypes, safeSubTypes, classifications } =
        store?.client.classifications
    return {
        makes,
        models,
        safeTypes,
        safeSubTypes,
        cities: store?.client.regrounds?.cities.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
        states: store?.client.regrounds?.states.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
        userId: store?.auth?.user?.id,
        inspectionForm:
            store?.inspection?.inspectionInfo?.inspectionForm?.questions,
        inspectionFormId: store?.inspection?.inspectionInfo?.inspectionForm?.id,
        inspectionDetail: store?.inspection?.inspectionInfo?.inspections,
        classifications,
        detailInspection: store?.inspection?.inspectionInfo?.detailInspection,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getClassifications } = ClassificationAction
    const { MAKE, MODEL, SAFE_TYPE, SAFE_SUB_TYPE } = EClassifications
    return {
        getMakes: () => dispatch(getClassifications(MAKE) as any),
        getModels: (params: ICommonQuery) =>
            dispatch(getClassifications(MODEL, params) as any),
        getSafeTypes: () => dispatch(getClassifications(SAFE_TYPE) as any),
        getSafeSubTypes: (params: any) =>
            dispatch(getClassifications(SAFE_SUB_TYPE, params) as any),
        getForm: () =>
            dispatch(InspectionInfoActions.getInspectionForm() as any),
        createForm: (payload: any) =>
            dispatch(
                InspectionInfoActions.createInspectionForm(payload) as any
            ),
        getInspectionBySearch: () => {
            dispatch(InspectionInfoActions.getInspectionSchedules() as any)
        },
        getClassificationsBySuggestion: (params: any) =>
            dispatch(
                ClassificationAction.getClassificationsBySuggestion(
                    params
                ) as any
            ),
        setInspectionQueries: (params?: ICommonQuery) =>
            dispatch(InspectionInfoActions.setInspectorQueries(params) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InspectionInfo)
